var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"71aa6aa94ecd9b427da833e5d7a2fb04cfa19b5c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["buscounchollo-prod@sentry"]={id:"71aa6aa94ecd9b427da833e5d7a2fb04cfa19b5c"};
      